<template>
    <div class="main-content">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" style="height:90%">
            <el-form-item label="公司名称" class="input" prop="companyName">
                <el-input style="width:100%;" v-model="ruleForm.companyName" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="精度" class="input" prop="lat">
                <el-input style="width:100%;" v-model="ruleForm.lat" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="维度" class="input" prop="lon">
                <el-input style="width:100%;" v-model="ruleForm.lon" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="公司地址" class="input" prop="address">
                <el-input style="width:100%;" v-model="ruleForm.address" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="系统介绍" class="input" prop="context">
                <editor style="width:100%;" v-model="ruleForm.context" autocomplete="off" rows="40"
                          placeholder="请输入系统介绍"></editor>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" @click="commit()">更新</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import base from '@/utils/base' // 导入配置的默认值
    import editor from '@/components/common/Editor'
    export default {
        compent:{editor},
        name:'recommendUpdate',
        data() {
            return {
                url:base.get().url,
                ruleForm: {
                    context: '',
                    id:'1',
                    context:'',
                    lat:'',
                    lon:'',
                    address:'',
                    companyName:'',
                },
                rules:{
                    context:[{ required: true, message: '请输入系统介绍', trigger: 'blur' }],
                    companyName:[{ required: true, message: '请输入系统名称', trigger: 'blur' }],
                    lat:[{ required: true, message: '请输入精度', trigger: 'blur' }],
                    lon:[{ required: true, message: '请输入维度', trigger: 'blur' }],
                    address:[{ required: true, message: '请输入公司地址', trigger: 'blur' }],
                },
            }
        },
        methods:{
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.url+`sysRecommend/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "更新成功！",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            loaddingData(){
                this.$http({
                    url:  this.url+"sysRecommend/info/1",
                    method: "get",
                    data:this.ruleForm
                }).then(({ data }) => {
                    this.ruleForm.context = data.data.context;
                    this.ruleForm.companyName = data.data.companyName;
                    this.ruleForm.lat = data.data.lat;
                    this.ruleForm.lon = data.data.lon;
                    this.ruleForm.address = data.data.address;
                });
            }
        },
        created(){
            this.loaddingData();
        }
    }
</script>